const Xs = '500px'
const Sm = '740px'
const Md = '900px'
const Lg = '1080px'
const Xl = '1200px'
const Xxl = '1540px'

export const Theme = {
  breakpoints: [Xs, Sm, Md, Lg, Xl, Xxl],
  colors: {
    orange: '#ec7824',
    darkOrange: '#ac4800',
    mediumOrange: '#db6d1c',
    lightOrange: '#fa9850',
    darkBlue: '#00608b',
    blue: '#0c87be',
    lightBlue: '#61c4f0',
    darkGreen: '#3b793d',
    green: '#5a995c',
    lightGreen: '#73b975',
    gray: '#676767',
    lightGray: '#b3b3b3',
    gray5: '#adabab',
    gray4: '#c7c4c4',
    gray3: '#d8d5d5',
    gray2: '#e3e0e0',
    gray1: '#f0f0f0',
    gray0: '#f8f8f8',
    black: '#222',
    white: '#ffffff'
  },
  space: [0, 4, 8, 12, 16, 24, 32, 48, 64, 128, 256],
  fonts: {
    title: 'itc-avant-garde-gothic-pro, sans-serif',
    text: 'Open Sans, sans-serif'
  },
  fontSizes: [
    '.875rem',
    '1rem',
    '1.125rem',
    '1.25rem',
    '1.375rem',
    '1.5rem',
    '1.875rem',
    '2.25rem',
    '4rem'
  ], //14, 16,18,20,22, 24,30,36, 72
  widths: ['812px', '1088px', '1635px']
}

export const breakpoints = {
  xs: Xs,
  sm: Sm,
  md: Md,
  lg: Lg,
  xl: Xl,
  xxl: Xxl
}

export const MediaQueries = Object.keys(breakpoints).reduce((acc, breakKey) => {
  return {
    ...acc,
    [breakKey]: `@media (max-width: ${breakpoints[breakKey]})`
  }
}, {})
// note: needs a separate property for border color
